import React, { useEffect, useState } from 'react'
import ContentHeader from 'components/UI/ContentHeader/ContentHeader'
import { superAxiosRequest } from 'axiosApi'
import { timeConverter } from 'components/ContentBox/Online-schedule/components/functions'
import LineChart from '../Charts/LineChart'
import DoughnutChart, { localTimeConverter } from '../Charts/DoughnutChart'
import st from './StatisticClients.module.scss'
import Loader from 'components/UI/Loader/Loader'
import { observer } from 'mobx-react'
import useLocalStorageFilter from 'helpers/useLocalStorageFilter'
import AsideFilterStore from 'components/UI/AsideFilter/asideFilterStore'
import SearchBooks from 'components/Modules/Ebook/Books/components/SearchBooks/SearchBooks'
import FilterTextValues from 'components/UI/AsideFilter/FilterTextValues'
import AsideFilter from 'components/UI/AsideFilter/AsideFilter'
import useLocalization from 'hooks/useLocalization'

const filterTypes = [
  { id: 1, name: 'По дням', key: 'days' },
  { id: 2, name: 'По неделям', key: 'weeks' },
  { id: 3, name: 'По месяцам', key: 'months' },
]

const filterCnf = [
  {
    type: 'date_day_picker',
    nameState: ['date_from', 'date_until'],
    label: 'Период',
  },
  {
    type: 'type_selector',
    nameState: 'type',
    label: 'Даты',
    values: filterTypes,
    query_key: true,
  },
  {
    nameState: 'funnel',
    placeholder: 'Воронка',
    apiLinkCRM: 'integration/funnels',
    type: 'select',
    label: 'Воронка',
    isRequired: true,
  },
  {
    type: 'select-multi',
    apiLinkCRM: 'i/?not_id=1',
    nameState: 'status_deal',
    label: 'По статусу',
    placeholder: 'По статусу',
  },
]

const requestLinks = {
  lineGraph: 'groups/stat',
  writtenTest: 'placement_test/stat',
  oralTest: 'online_schedule/stat',
  signedGroup: 'progress_report/group_join',
}

const lineColors = ['rgb(255, 99, 132)', 'rgb(51, 102, 13)', 'rgb(0, 77, 194)']

const findData = (array, id) => array.filter((item) => item.id === id)[0]?.total

const getPercent = (totalValue, value) =>
  Math.round((value / totalValue) * 100) || '<1'

const getTotal = (arr) =>
  arr[0].total !== undefined
    ? arr.map((item) => item.total)
    : arr.map((item) => item.data.total)

const getLineDataset = (keys, lineData) =>
  keys.map((key, idx) => ({
    label: key,
    title: 'test',
    data: getTotal(lineData[key]),
    borderColor: lineColors[idx],
    backgroundColor: lineColors[idx],
    pointRadius: 5,
    pointBorderWidth: 2,
    pointBorderColor: 'rgb(255, 255, 255)',
  }))

const requestHandlerTemplate = {
  lineGraph({ data }, typeRequest, prev) {
    const keys = Object.keys(data)
    return {
      ...prev,
      lineGraph: {
        datasets: getLineDataset(keys, data),
        labels: data[keys[0]].map(() => ''),
      },
    }
  },
  writtenTest({ data: { placement_test: data } }, typeRequest, prev) {
    return {
      ...prev,
      doughnutChartData: {
        ...prev.doughnutChartData,
        writtenTest: {
          label: 'ШАГ 1. /* ПИСЬМЕННЫЙ ТЕСТ',
          filters:
            typeRequest === 'filterRequest'
              ? prev.doughnutChartData.writtenTest.filters
              : [
                  {
                    type: 'bound',
                    boundFilters: [
                      {
                        nameFeild: 'widget',
                        placeholder: 'Все виджеты',
                        options: data.widgets.map(({ id, name }) => ({
                          id,
                          name,
                        })),
                      },
                      {
                        nameFeild: 'bundle',
                        placeholder: 'Все связки',
                        options: data.widgets.map((item) => ({
                          selectId: item.id,
                          data: item.bundles.map(({ id, name }) => ({
                            id,
                            name,
                          })),
                        })),
                      },
                    ],
                  },
                ],
          total: {
            test: {
              value: data.total_data.total,
              label: 'всего письменных тестов',
            },
            time: {
              value: new Date(data.total_data.avg_time * 1000),
              label: 'среднее время /n прохождения теста',
            },
          },
          rightArray: data.widgets.map((item) => ({
            procent: getPercent(
              data.total_data.total,
              findData(data.widget_data, item.id),
            ),
            value: findData(data.widget_data, item.id),
            label: item.name,
          })),
          leftArray: [
            {
              procent: getPercent(data.total_data.total, data.test_data.unique),
              value: data.test_data.unique,
              label: 'Уникальных тестов',
            },
            {
              procent: getPercent(
                data.total_data.total,
                data.test_data.time_out,
              ),
              value: data.test_data.time_out,
              label: 'Вышло время',
            },
            {
              procent: getPercent(
                data.total_data.total,
                data.test_data.finished,
              ),
              value: data.test_data.finished,
              label: 'Завершенных тестов',
            },
            {
              procent: getPercent(
                data.total_data.total,
                data.test_data.test_only,
              ),
              value: data.test_data.test_only,
              label: 'Только сбор данных',
            },
          ],
        },
      },
    }
  },
  oralTest({ data }, typeRequest, prev) {
    const totalOralTests =
      data.type_slots.past +
      data.type_slots.cancelled +
      data.type_slots.no_client

    return {
      ...prev,
      doughnutChartData: {
        ...prev.doughnutChartData,
        oralTest: {
          label: 'ШАГ 2. /* УСТНЫЙ ТЕСТ',
          filters:
            typeRequest === 'filterRequest'
              ? prev.doughnutChartData.oralTest.filters
              : [
                  {
                    nameFeild: 'age',
                    placeholder: 'Все возраста',
                    type: 'normal',
                    options: data.ages.map(({ id, name }) => ({ id, name })),
                  },
                ],
          total: {
            test: {
              value: totalOralTests,
              label: 'всего устных тестов',
            },
            time: {
              value: new Date(data.total_data[0].avg_time * 1000),
              label: `среднее время между /n регистрацией и тестом`,
            },
          },
          rightArray: [
            ...data.type_program.map((item) => ({
              procent: getPercent(data.type_slots.past, item.total),
              value: item.total,
              label: item.name,
            })),
            // Конверсия в зависимости от уникальных письменных тестов
            {
              procent: Math.round(data.total_data[0].conversion),
              value: '',
              label: 'Конверсия',
            },
          ],
          leftArray: [
            {
              procent: getPercent(totalOralTests, data.type_slots.past),
              value: data.type_slots.past,
              label: 'Проведенные тесты',
            },
            {
              procent: getPercent(totalOralTests, data.type_slots.cancelled),
              value: data.type_slots.cancelled,
              label: 'Отмененные тесты',
            },
            {
              procent: getPercent(totalOralTests, data.type_slots.no_client),
              value: data.type_slots.no_client,
              label: 'Клиент не пришел',
            },
          ],
        },
      },
    }
  },
  signedGroup({ data }, typeRequest, prev) {
    const averageMilliseconds = data.average_seconds * 1000
    const date = new Date(averageMilliseconds)

    return {
      ...prev,
      doughnutChartData: {
        ...prev.doughnutChartData,
        signedGroup: {
          label: 'ШАГ 3. /* ПЕРВОЕ ЗАНЯТИЕ В ГРУППЕ',
          filters:
            typeRequest === 'filterRequest'
              ? prev.doughnutChartData.signedGroup.filters
              : [
                  {
                    nameFeild: 'discipline',
                    placeholder: 'Все типы групп',
                    type: 'normal',
                    options: data.disciplines.filter((discipline) =>
                      data.discipline_split.some(
                        (discipline_split) =>
                          discipline_split.id === discipline.id,
                      ),
                    ),
                  },
                ],
          total: {
            test: {
              value: data.total,
              label: 'всего платных первых занятий',
            },
            time: {
              value: date,
              label: `среднее время между тестами /n и первым занятием`,
            },
          },
          rightArray: [
            ...data.disciplines
              .filter((discipline) =>
                data.discipline_split.some(
                  (discipline_split) => discipline_split.id === discipline.id,
                ),
              )
              .map((discipline) => {
                const value = findData(data.discipline_split, discipline.id)
                const procent =
                  value !== undefined && value !== null
                    ? getPercent(data.total, value)
                    : 0

                return {
                  procent: procent,
                  value: value || 0,
                  label: discipline.name,
                }
              }),
            // Конверсия в зависимости от проведенных устных тестов
            {
              procent: Math.round(data.conversion),
              value: '',
              label: 'Конверсия',
            },
          ],
          leftArray: [],
        },
      },
    }
  },
}

const StatisticClients = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [filter, updateFilter] = useLocalStorageFilter()
  const {
    isOpenFilter,
    closeFilter,
    setTextValues,
    changeTextValue,
    filterTextValues,
  } = AsideFilterStore

  const { translate } = useLocalization({
    section: 'ebooks',
    subsection: 'ebooks_books',
    dict: {
      edit: 'Edit',
      copy: 'Copy',
      delete: 'Delete',
      save: 'Save',
      filter: 'Filter',
      company: 'Company',
      reset_all: 'Reset all',
      apply: 'Apply',
      search: 'Search',
      start_date: 'Start date',
      end_date: 'End date',
    },
  })

  const date = new Date()
  const [apiConf, setApiConf] = useState({
    method: 'get',
    params: {
      date_from: timeConverter(new Date(date - 24 * 60 * 60 * 1000), 'today'),
      date_until: timeConverter(date, 'today'),
      type: 'days', //week, month
    },
  })
  const [chartData, setChartData] = useState({
    doughnutChartData: {},
    lineGraph: {
      labels: [''],
      datasets: [
        {
          label: 'Dataset 1',
          data: [1],
          borderColor: 'rgb(255, 99, 132)',
          backgroundColor: 'rgba(255, 99, 132)',
          pointRadius: 4,
          pointBorderColor: 'rgb(255, 255, 255)',
        },
      ],
    },
  })

  const params = {
    ...filter,
  }

  const getDoughnutChartData = (requestParam, chartName) => {
    setIsLoading(true)
    superAxiosRequest({
      ...apiConf,
      link: requestLinks[chartName],
      type: 'days',
      params: { ...params, ...requestParam },
    }).then((response) => {
      setChartData(
        requestHandlerTemplate[chartName](response, 'filterRequest', chartData),
      )
      setIsLoading(false)
    })
  }

  useEffect(() => {
    setIsLoading(true)
    const graphs = Object.keys(requestLinks)
    const apiConfToSend = {
      ...apiConf,
      params: {
        ...apiConf?.params,
        ...filter,
      },
    }
    const requests = graphs.map((key) =>
      superAxiosRequest(
        { ...apiConfToSend, link: requestLinks[key] },
        null,
        null,
        {
          timeout: 90000,
        },
      ),
    )
    Promise.all(requests).then((arr) => {
      setChartData(
        graphs.reduce(
          (acc, key, idx) => requestHandlerTemplate[key](arr[idx], null, acc),
          chartData,
        ),
      )
      setIsLoading(false)
    })
  }, [apiConf, filter])

  const { lineGraph, doughnutChartData } = chartData

  return isLoading ? (
    <Loader />
  ) : (
    <div>
      <ContentHeader title='Сводный отчет: этапы работы с клиентами' />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          margin: '10px',
        }}
      >
        <SearchBooks
          onSearch={(text) => {
            updateFilter({ ...filter, search: text })
            changeTextValue('search', {
              key: 'search',
              label: 'Search',
              value: text,
            })
          }}
          onClear={() => {
            const { search, ...obj } = filter
            updateFilter(obj)
            setTextValues(
              filterTextValues.filter((field) => field.key !== 'search'),
            )
          }}
          translate={translate}
          placeholder={`Search...`}
          value={filter?.search || ''}
        />
        {!!filterTextValues.length && (
          <FilterTextValues
            onDelete={(key) => {
              const { [key]: _, ...obj } = filter
              updateFilter(obj)
            }}
          />
        )}
        {isOpenFilter && (
          <AsideFilter
            translate={translate}
            getFilterParams={updateFilter}
            config={filterCnf}
            filterValue={filter}
            onDropFilter={() => {
              updateFilter({})
              closeFilter()
            }}
          />
        )}
      </div>
      <div className={st.wrapper}>
        {lineGraph && <LineChart newData={lineGraph} />}
        {Object.keys(requestLinks)
          .slice(1)
          .map((chartName) =>
            doughnutChartData[chartName] ? (
              <DoughnutChart
                key={chartName}
                chartName={chartName}
                chartData={doughnutChartData[chartName]}
                getFilterParams={getDoughnutChartData}
                defaultParams={{
                  date_from: filter?.date_from || apiConf?.params?.date_from,
                  date_until: filter?.date_until || apiConf?.params?.date_until,
                  type: filter?.type || apiConf?.params?.type,
                }}
              />
            ) : null,
          )}
        <div className={st.total}>
          <div className={st.totalRow}>
            <span>Конверсия всех этапов</span>
            <span>
              {getPercent(
                doughnutChartData.writtenTest?.leftArray[0].value,
                doughnutChartData.signedGroup?.total.test.value,
              )}
              &nbsp;%
            </span>
          </div>
          <div className={st.totalRow}>
            <span>Среднее время прохождения всех этапов</span>
            <span>
              {localTimeConverter(
                new Date(
                  doughnutChartData.writtenTest?.total.time.value.getTime() +
                    doughnutChartData.oralTest?.total.time.value.getTime() +
                    doughnutChartData.signedGroup?.total.time.value.getTime(),
                ),
              )}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default observer(StatisticClients)
